import { Stat, StatLabel, StatNumber, StatGroup, 
    Tabs, TabList, TabPanels, Tab, TabPanel, Flex, Box
} from '@chakra-ui/react';
import formatCurrency from '../../utility/formatCurrency';
import convertTimestampToDate from '../../utility/convertTimestampToDate';
import CashflowTable from './cashflowTable';
import CashflowChart from './cashflowChart';
import StockPriceChart from './stockPriceChart';
import FundamentalsPanel from './fundamentals';

const StockData = ({ stockInfo, balancesheet, cashflowStatement, priceHistory }) => {
    
    return (
        <Tabs mt={4}>
            <TabList>
                <Tab>Summary</Tab>
                {/* <Tab>Fundamentals</Tab> */}
                <Tab>Cashflow statement</Tab>
                <Tab>Stock price</Tab>
            </TabList>
            <TabPanels>
                <TabPanel>
                    <StatGroup>
                        <Stat>
                            <StatLabel>Nome Azienda</StatLabel>
                            <StatNumber>{stockInfo.longName}</StatNumber>
                        </Stat>

                        <Stat>
                            <StatLabel>Prezzo Attuale</StatLabel>
                            <StatNumber>{formatCurrency(stockInfo.currentPrice, stockInfo.currency)}</StatNumber>
                        </Stat>

                        <Stat>
                            <StatLabel>Capitalizzazione di Mercato</StatLabel>
                            <StatNumber>{formatCurrency(stockInfo.marketCap, stockInfo.currency)}</StatNumber>
                        </Stat>

                        <Stat>
                            <StatLabel>Free Cash Flow ({cashflowStatement[cashflowStatement.length - 1].date})</StatLabel>
                            <StatNumber>
                                {isNaN(cashflowStatement[cashflowStatement.length - 1].freeCashFlow) ? (
                                    '----'
                                ) : (
                                    formatCurrency(cashflowStatement[cashflowStatement.length - 1].freeCashFlow, stockInfo.currency)
                                )}
                            </StatNumber>
                        </Stat>

                        <Stat>
                            <StatLabel>Dividendo</StatLabel>
                            <StatNumber>{stockInfo.dividendRate ? formatCurrency(stockInfo.dividendRate, stockInfo.currency) : 'N/A'}</StatNumber>
                        </Stat>
                    </StatGroup>
                </TabPanel>
                {/* <TabPanel>
                    <Flex justifyContent="center">
                        <Box>
                            <FundamentalsPanel balancesheets={balancesheet}/>
                        </Box>
                    </Flex>
                </TabPanel> */}
                <TabPanel>
                    <Flex justifyContent="center">
                        <Box>
                            <CashflowChart cashflowStatement={cashflowStatement} currency={stockInfo.currency}/>
                            <CashflowTable cashflowStatement={cashflowStatement} currency={stockInfo.currency} mt={2}/>
                        </Box>
                    </Flex>
                </TabPanel>
                <TabPanel>
                    <StockPriceChart priceHistory={priceHistory}/>
                </TabPanel>
            </TabPanels>
        </Tabs>
    );
}

export default StockData;
